import React from 'react';
import { Product } from '../../components/Product/Product';
import { EmotionBreakpoint } from 'dw-us-ui';
import styled from '@emotion/styled';

const ProductListContainer = styled.div`
  ${EmotionBreakpoint('desktop')} {
    max-width: 970px;
  }
  ${EmotionBreakpoint('tablet')} {
    max-width: 720px;
  }
  @media (min-width: 576px) and (max-width: 768px) {
    max-width: 540px;
  }
  margin: auto;
  .product-listing {
    .loader-style {
      padding-bottom: 30px;
    }
  }
`;
const isUatAvailable = window.location.href.includes('ak.uat.');

const temp = { itemCode: 'M12068' };
const ProductListing = ({ fields, winePlanSubscription }) => {
  return (
    <ProductListContainer className={`py-5`}>
      <div data-testid="product-listing" className="product-listing">
        {isUatAvailable && <Product fields={temp} winePlanSubscription={winePlanSubscription} />}
        <Product fields={fields} winePlanSubscription={winePlanSubscription} />
      </div>
    </ProductListContainer>
  );
};

export { ProductListing };
